import * as React from "react";
import { useState, useEffect } from "react";
import {
  VStack,
  HStack,
  Button,
  Text,
  Box,
  Radio,
  Stack,
  Divider,
  Pressable,
  Checkbox,
  View,
} from "native-base";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Loc } from "../../App/Loc";
import AVInputtext from "../../components/AVInputtext";
import AVDropdown from "../../components/AVDropdown";
import { components } from "react-select";
import Dropdown from "../../assets/images/dropdown.svg";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import * as AV from "../../AVCore/AVCore";
import * as AVI from "../../AVCore/Interfaces/AV.Interfaces";
import { useSelector, useDispatch, RootStateOrAny } from "react-redux";
import {
  setEntitydata,
  setUser,
  setisActive,
} from "../../Redux/Actions/userActions";
import { HelpIcon, ColorPickerIcon } from "../../assets/icons/icon-assets";
import AVMascot from "./AVMascot";
import { GithubPicker } from "react-color";
import AVLocationBox from "./AVLocationBox";
import { Dimensions } from "react-native";
import AVDatePicker from "../../components/common/AVDatePicker";
import AVTimePicker from "../../components/common/AVTimePicker";
import dayjs, { Dayjs } from "dayjs";
import moment from "moment";
import AVFieldMap from "../../components/common/AVFieldMap";
import CustomToast from "../../Hooks/useCustomToast";
import AVConfirmationModal from "../../components/common/AVConfirmationModal";
import AddandEditLinks from "./AddandEditLinks";
import Offline from "react-offline";
import { findWindows } from "windows-iana";
import AVConfirmLinkPopup from "../../components/common/AVConfirmLinkPopup";

const AVCreateTeam = ({
  isCreate,
  setIsCreate,
  Entity,
  setEntity,
  isShowEdit,
  setIsShowEdit,
  teamType,
  profile,
  handleUpload,
  setProfile,
  type,
  EntityDataFinding,
  setgooglemap,
  setShowCreateNewPage,
  setCreateType,
  setPassEntity,
  passEntity,
  isEditEntireSeries,
  setIsEditEntireSeries,
  seriesEvent,
}) => {
  const navigate = useNavigate();
  const currentUser = useSelector(
    (state: RootStateOrAny) => state?.user?.user[0],
  );
  const location: any = useLocation();
  const params = useParams();
  const seriesId: any = params?.seriesId;
  const dimensions = Dimensions.get("window");
  const isMobile = dimensions?.width <= 600 || false;
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const orgFK = passEntity;
  const teamValue = teamType;
  const user = useSelector((state: RootStateOrAny) => state?.user?.user[0]);
  const [name, setName] = useState<any>("");
  const [description, setDescription] = useState<any>("");
  const [activity, setActivity] = useState<any>("");
  const [activityLoc, setActivityLoc] = useState<any>("");
  const [seasonName, setSeasonName] = useState<any>("");
  const [gender, setGender] = useState<any>("");
  const [Links, setLinks] = useState<any>("");
  const [gendertypelist, setgendertypelist] = useState<any>();
  const [activitytypelist, setactivitytypelist] = useState<any>();
  const entitydatalist = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );
  const [primaryColor, setPrimaryColor] = useState(
    Entity?.primaryColor || "black",
  );
  const [secondaryColor, setSecondaryColor] = useState(
    Entity?.secondaryColor || "#E7875E",
  );
  const [isPrimary, setIsPrimary] = useState(false);
  const [isSecondary, setIsSecondary] = useState(false);
  const [locationaddress, setlocationaddress] = useState<any>([]);
  const [mascotImage, setMascotImage] = useState<any>(
    Entity?.mascot ? AV.Media.getURL(Entity?.mascot) : null,
  );
  const [eventStartDate, setEventStartDate] = useState(
    Entity?.start ? moment(Entity?.start).format("YYYY-MM-DD") : "",
  );
  const [eventTeamArrivalDate, setTeamArrivalDate] = useState(
    Entity?.playerStart ? moment(Entity?.playerStart).format("YYYY-MM-DD") : "",
  );
  const [eventEndDate, setEventEndDate] = useState(
    Entity?.start ? moment(Entity?.end).format("YYYY-MM-DD") : "",
  );
  const [eventStartTime, setEventStartTime] = useState(
    Entity?.start ? Entity?.start : "",
  );
  const [eventEndTime, setEventEndTime] = useState<any>(
    Entity?.end ? Entity?.end : "",
  );
  const [startingTime, SetStartingTime] = useState("");
  const [endingTime, setEndingTime] = useState("");
  const [Player, setPlayer] = useState("");
  const [deleteLoader, SetDeleteLoader] = useState(false);
  const [eventLocation, setEventLocation] = useState<any>("");
  const [visiblefield, setVisibleField] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0); // Key prop for forcing re-render
  const [refreshTimeKey, setRefreshTimeKey] = useState(0); // Key prop for forcing re-render
  const [Playerstart, setPlayerStart] = useState<any>(
    Entity?.playerStart ? Entity?.playerStart : "",
  );
  const [isActives, setIsActives] = useState(false);
  const [FieldValue, setFieldValue] = useState("");
  const [mapField, setIsMapField] = useState(
    Entity?.location?.field?.name ? Entity?.location?.field?.name : "",
  );
  const [locationEntity, setLocationEntity] = useState<any>();
  const [isFieldsName, setIsFieldsName] = useState<any>();
  const urlRegex =
    /^(https?|ftp):\/\/[a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})?(:\d+)?(\/\S*)?$/;
  const [message, setMessage] = useState(
    Loc.currentLang.helpText.invalidUrlMessage,
  );
  const [isConfirmDelete, setisConfirmDelete] = useState(false);
  const [Confirmationtext, setConfirmationtext] = useState("Are you sure ?");
  const [selectType, setselectType] = useState<any>();
  const [itemSelect, setItemSelect] = useState<any>("");
  const [isLoader, setLoader] = useState(false);
  const [addLinkPopup, setAddLinkPopup] = useState(false);
  const [linkList, setLinksList] = useState<any>([]);
  const CurrentDateTime = new Date();
  CurrentDateTime.setMinutes(0);
  const year = CurrentDateTime.getFullYear();
  const month = (CurrentDateTime.getMonth() + 1).toString().padStart(2, "0");
  const day = CurrentDateTime.getDate().toString().padStart(2, "0");
  const DefaultEventDate = `${year}-${month}-${day}`;
  const [addLink, setAddLink] = useState(false);
  const [url, setUrl] = useState("");
  const adjustedEventTime = CurrentDateTime.toLocaleTimeString([], {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  const [triggerEndDate, setTriggerEndDate] = useState(false);
  const [triggerStartTime, setTriggerStartTime] = useState(false);
  const formatTime = (timeString) => {
    if (!timeString) return ""; // Return empty string if timeString is empty or undefined
    const time = new Date(timeString); // Create a Date object from the timeString
    let hours = time.getHours();
    const minutes = time.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM"; // Determine whether it's AM or PM
    hours %= 12; // Convert hours to 12-hour format
    hours = hours || 12; // Handle 0 as 12
    const formattedTime = `${hours}:${minutes < 10 ? "0" : ""}${minutes} ${ampm}`; // Format the time
    return formattedTime;
  };
  const mobile = dimensions?.width < 600 || false;
  const [isconfirmLoading, setisconfirmLoading] = useState(false);
  const startTime = formatTime(eventStartTime);
  const endTime = formatTime(eventEndTime);
  const [editEventStartingTime, setEditEventStartingTime] = useState(startTime);
  const [editEventEndingTime, setEditEventEndingTime] = useState(endTime);
  const [isValidUrl, setIsValidUrl] = useState(true); // Initialize as true assuming the URL is initially valid

  // Pet
  const [petType, setPetType] = useState<string>("");
  const [petBreed, setPetBreed] = useState<string>("");
  const [petSubBreed, setPetSubBreed] = useState<string>("");
  const [petAdoptionDate, setPetAdoptionDate] = useState<Date | null>(
    Entity?.adoptionDate ?? new Date(),
  );
  const [petMicrochipId, setPetMicrochipId] = useState<string>("");

  const [clickedUrl, setClickedUrl] = useState("");
  const [showConfirmLinkPopup, setShowConfirmLinkPopup] = useState(false);

  //Url
  const handleEventUrl = (e) => {
    e.preventDefault();
    setUrl(e.target.value);
    const inputUrl = e.target.value;
    const isValidLink =
      /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
    setIsValidUrl(isValidLink.test(inputUrl));
    setUrl(inputUrl); // Assuming you're updating the URL state here
  };

  let reference =
    type === "Organization"
      ? {
          isPrivate: false,
          autoFollow: false,
          allowFollowersPosts: false,
        }
      : {
          isPrivate: false,
          autoFollow: false,
          allowFollowersPosts: false,
          allowReplyPosts: false,
          allowAllToPost: false,
        };
  const [Prefernces, setPrefernces] = useState<any>(reference);
  const [GroupType, setGroupType] = useState({
    isPrivate: false,
    autoapprove: false,
    allowfollwerstopost: false,
    autoreplytopost: false,
    allowalltopost: false,
    allowmemberstopost: true,
    selectedPreference: "Normal Group", // Initial or default value
  });

  const [error, setError] = useState("");
  const [isValidStartDate, setIsValidStartDate] = useState(true);
  const [isValidEndDate, setIsValidEndDate] = useState(true);
  const [isValidStartTime, setIsValidStartTime] = useState(true);
  const [isValidEndTime, setIsValidEndTime] = useState(true);

  // Collect
  const [collectStartDate, setCollectStartDate] = useState<Date | null>(
    Entity?.start ?? new Date(),
  );
  const [collectEndDate, setCollectEndDate] = useState<Date | null>(
    Entity?.end ?? new Date(),
  );
  const [isCollectDateError, setIsCollectDateError] = useState(false);

  const validateCollectDates = (start: Date | null, end: Date | null) => {
    const today = dayjs().startOf("day");

    if (!start || !end)
      return {
        isError: true,
        message: Loc.currentLang.feeCollect.requiredDates,
      };

    const startDay = dayjs(start).startOf("day");
    const endDay = dayjs(end).startOf("day");

    if (!startDay.isValid() || !endDay.isValid())
      return {
        isError: true,
        message: Loc.currentLang.feeCollect.invalidDate,
      };

    if (startDay.isBefore(today))
      return {
        isError: true,
        message: Loc.currentLang.feeCollect.startDatePast,
      };

    if (endDay.isBefore(today))
      return {
        isError: true,
        message: Loc.currentLang.feeCollect.endDatePast,
      };

    if (startDay.isAfter(endDay))
      return {
        isError: true,
        message: Loc.currentLang.feeCollect.startAfterEnd,
      };

    return { isError: false, message: "" };
  };

  const handleCollectStartDate = (date: Dayjs | null) => {
    const newStart = date && date.isValid() ? date.toDate() : null;

    setCollectStartDate(newStart);
    //setIsCollectDateError(validateCollectDates(newStart, collectEndDate));
  };

  const handleCollectEndDate = (date: Dayjs | null) => {
    const newEnd = date && date.isValid() ? date.toDate() : null;

    setCollectEndDate(newEnd);
    //setIsCollectDateError(validateCollectDates(collectStartDate, newEnd));
  };

  const dropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <img src={Dropdown} alt="Dropdown" style={{ width: "25px" }} />
      </components.DropdownIndicator>
    );
  };

  const handleBannerColor = (color) => {
    if (isPrimary) {
      setPrimaryColor(color.hex);
      setIsPrimary(false);
    } else {
      setSecondaryColor(color.hex);
      setIsSecondary(false);
    }
  };

  const customS = {
    maxHeight: "53px", // Set your desired height here
  };

  const handleIntroText = (e) => {
    e.preventDefault();
    setDescription(e?.target?.value);
    setProfile((profile) => ({ ...profile, text: e.target.value.trim() }));
  };

  //StartDate
  const handleEventStartDate = (e) => {
    if (e != null) {
      const inputDate = new Date(e);

      // Check if valid date
      if (isNaN(inputDate.getTime())) {
        setIsValidStartDate(false);
        setEventStartDate("");
        //setError("Invalid date entered");
        return;
      }

      // Dynamic century validation
      const currentYear = new Date().getFullYear();
      const startCentury = Math.floor(currentYear / 100) * 100;
      const endCentury = startCentury + 99;

      const year = inputDate.getFullYear();
      if (year < startCentury || year > endCentury) {
        setIsValidStartDate(false);
        setEventStartDate("");
        //setError(`Please select a date within this century (${startCentury} - ${endCentury})`);
        return;
      }

      // Format date
      const date = new Date(e);
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
      const formattedDate = date.toISOString().split("T")[0];
      setEventStartDate(formattedDate);
      setError("");
      setIsValidStartDate(true);

      // Adjust end date
      if (formattedDate > eventEndDate) {
        setEventEndDate(formattedDate);
        const timer = setTimeout(() => {
          setTriggerEndDate(!triggerEndDate);
        }, 2000);
      }
    } else {
      setIsValidStartDate(false);
    }
  };

  //EndDate
  const handleEventEndDate = (e) => {
    if (e != null) {
      const inputDate = new Date(e);

      // Check if valid date
      if (isNaN(inputDate.getTime())) {
        setIsValidEndDate(false);
        setEventEndDate("");
        //setError("Invalid date entered");
        return;
      }

      // Dynamic century validation
      const currentYear = new Date().getFullYear();
      const startCentury = Math.floor(currentYear / 100) * 100;
      const endCentury = startCentury + 99;

      const year = inputDate.getFullYear();
      if (year < startCentury || year > endCentury) {
        setIsValidEndDate(false);
        setEventEndDate("");
        //setError(`Please select a date within this century (${startCentury} - ${endCentury})`);
        return;
      }

      // Format date
      const date: any = new Date(e);
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
      const formattedDate = date.toISOString().split("T")[0];

      setEventEndDate(formattedDate);
      setError("");
      setIsValidEndDate(true);
    } else {
      setIsValidEndDate(false);
    }
  };

  const handleupdatelocationfield = (e, siteField) => {
    setIsMapField(e?.name);
    setIsFieldsName(siteField?.find((x: any) => x?.name == e));
  };

  let concatfieldmap = {
    field: isFieldsName ? isFieldsName : locationEntity?.field,
    siteMap: locationEntity?.siteMap,
  };

  let locationoffield = {
    ...locationaddress,
    ...concatfieldmap,
  };

  const correctTimeFormat = (timeString: any) => {
    const time = timeString.toLowerCase();
    const timeRegex = /^(\d{1,2}):(\d{2}) ([ap]m)$/;
    const match = time.match(timeRegex);

    if (match) {
      let hour = parseInt(match[1], 10);
      const minute = match[2];
      const period = match[3].toUpperCase(); // Convert "am/pm" to uppercase
      if (period === "PM" && hour !== 12) {
        hour += 12;
      } else if (period === "AM" && hour === 12) {
        hour = 0;
      }

      const formattedTime = `${hour.toString().padStart(2, "0")}:${minute}`;
      return formattedTime;
    }

    return timeString;
  };

  //StartTime
  const handleEventStartTime = async (e) => {
    handlechange(e);
    const myDate: any = new Date(e);
    if (myDate.toString() === "Invalid Date" || isNaN(myDate) || e == null) {
      setIsValidStartTime(false);
      setEventStartTime("");
      return;
    }

    const timeString = myDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    let val = await correctTimeFormat(timeString);
    const [hours, minutes] = val.split(":").map(Number);
    let newdate = new Date(eventStartDate);
    newdate.setHours(hours);
    newdate.setMinutes(minutes);
    setEventStartTime(newdate);
    setEditEventStartingTime(timeString);
    setIsValidStartTime(true);

    //if (eventStartDate === eventEndDate) {
    //  const newdatePlusOneHourClone = new Date(eventStartDate);
    //  newdatePlusOneHourClone.setHours(hours);
    //  newdatePlusOneHourClone.setMinutes(minutes);
    //  newdatePlusOneHourClone.setHours(newdatePlusOneHourClone.getHours() + 1);
    //  setEventEndTime(newdatePlusOneHourClone);
    //  if (newdate >= new Date(eventEndTime)) {
    //    const timer = setTimeout(() => {
    //      setTriggerStartTime(!triggerStartTime);
    //    }, 2000);
    //  }
    //  handlechangeend(newdatePlusOneHourClone);
    //}
  };

  const handlechange = (e) => {
    const myDate: any = new Date(e);
    if (myDate.toString() === "Invalid Date" || isNaN(myDate) || e == null) {
      setIsValidStartTime(false);
      SetStartingTime("");
      return;
    }

    const currentHour = myDate.getHours();
    const newDate = new Date(myDate);
    newDate.setHours(currentHour);
    const timeString = newDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    SetStartingTime(timeString);
  };

  //EndTime
  const handleEventEndTime = async (e) => {
    const myDate: any = new Date(e);
    if (myDate.toString() === "Invalid Date" || isNaN(myDate) || e == null) {
      setIsValidEndTime(false);
      setEventEndTime("");
      setEndingTime("");
      return;
    }

    handlechangeend(e);
    const timeString = myDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    let val = await correctTimeFormat(timeString);
    const [hours, minutes] = val.split(":").map(Number);
    let newdate = new Date(eventEndDate);
    newdate.setHours(hours);
    newdate.setMinutes(minutes);
    setEventEndTime(newdate);
    setEditEventEndingTime(timeString);
  };

  const handlechangeend = (e) => {
    const myDate: any = new Date(e);
    if (myDate.toString() === "Invalid Date" || isNaN(myDate) || e == null) {
      setIsValidEndTime(false);
      setEventEndTime("");
      setEndingTime("");
      return;
    }

    setIsValidEndTime(true);
    const currentHour = myDate.getHours();
    const newDate = new Date(myDate);
    newDate.setHours(currentHour);
    const timeString = newDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    setEndingTime(timeString);
    setEditEventEndingTime(timeString);
  };

  const handleEventTeamArrival = (e) => {
    if (e !== null) {
      const inputDate = new Date(e);
      // Check if the entered date is a valid date
      if (isNaN(inputDate.getTime())) {
        let clientError = { message: "Invalid date entered" };
        //CustomToast({ clientError });
        setIsValidStartDate(false);
        // You can set an error state or display an error message here
        return;
      }

      const date = new Date(e);
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
      const formattedDate = date.toISOString().split("T")[0];
      setTeamArrivalDate(formattedDate);
      setIsValidStartDate(true);
    } else {
      setTeamArrivalDate("");
    }
  };

  const handleEventTeamArival = (e) => {
    if (e !== null) {
      const myDate = new Date(e);
      const timeString = myDate.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
      setPlayerStart(timeString);
      setPlayer(timeString);
    } else {
      setPlayer("");
    }
  };

  const HandleName = (e) => {
    setName(e?.target?.value);
  };

  const HandleLocationMap = async (e: any) => {
    let map: any = await AV.Location.updateMap(locationaddress);
  };

  const HandleSeasonName = (e) => {
    setSeasonName(e?.target?.value);
  };

  const HandleActivity = (e) => {
    console.log("Activity", e);
    setActivity(e?.value);
    setActivityLoc(e?.label);
  };

  const HandleGender = (e) => {
    console.log("Gender E", e);
    setGender(e?.target?.value);
  };

  const handleDeleteEvent = () => {
    setisConfirmDelete(true);
    setConfirmationtext(Loc.currentLang.menu.eventCancelConfirmText);
    setselectType("DeleteEvent");
  };

  const handleUncancelEvent = () => {
    try {
      console.log("implement Uncancel event");
    } catch (e) {
      console.log("Error in Un-cancel Event", e);
    }
  };

  const DeleteAccount = async () => {
    setLoader(true);

    try {
      if (
        seriesId &&
        seriesId !== "undefined" &&
        seriesId !== undefined &&
        Entity?.series !== undefined &&
        !isEditEntireSeries
      ) {
        console.log({ Entity, seriesEvent }, "sdsdsd");
        let fk = {
          id: Entity.series,
          pk: Entity.series.slice(-4),
          region: Entity.region,
          type: Entity.type,
        };
        await AV.Event.cancelSeries(fk, seriesEvent?.id);
        // Find the index of the target entity in the entitydatalist
        const entityIndex = entitydatalist.findIndex(
          (x) => x?.id === Entity?.id,
        );

        // Check if the entity exists
        if (entityIndex !== -1) {
          // Get the specific entity
          const event = { ...entitydatalist[entityIndex] };

          // Find the index of the specific seriesEvent within the event
          const seriesEventIndex = event.seriesEvents.findIndex(
            (se) => se?.id === seriesEvent?.id,
          );

          // If the seriesEvent is found, update its status
          if (seriesEventIndex !== -1) {
            // Update the seriesEvent's status
            event.seriesEvents[seriesEventIndex] = {
              ...event.seriesEvents[seriesEventIndex],
              status: "Canceled",
            };

            // Update the entity in the entitydatalist
            const updatedEntitydatalist = [...entitydatalist];
            updatedEntitydatalist[entityIndex] = event;
            setEntity(Entity);
            let finalUser = await AV.Person.getSelf(true);
            dispatch(setUser(finalUser));
            // Dispatch the updated entitydatalist
            dispatch(setEntitydata(updatedEntitydatalist));
            navigate(
              `/Events/${Entity?.id}/${Entity?.region}/${seriesEvent?.id}`,
              { state: { team: Entity } },
            );
          }
        }

        //Entity.status = "Canceled";
        setEntity(Entity);
        setLoader(false);
        setIsShowEdit(false);
      } else {
        Entity.id = Entity.series ? Entity.series : Entity.id;
        await AV.Event.cancelEvent(AV.AVEntity.getFk(Entity));
        Entity.status = "Canceled";
        entitydatalist[
          entitydatalist.indexOf(
            entitydatalist?.find((x) => x?.id === Entity?.id),
          )
        ] = Entity;

        let data: any = currentUser.events?.filter((x) => x?.id == Entity?.id);
        if (data) {
          data[0].status = "Canceled";
          data[0].data = "Canceled";
          let finalUser = await AV.Person.getSelf(true);
          dispatch(setUser(finalUser));
        }
        dispatch(setEntitydata(entitydatalist));
        setLoader(false);
        setIsShowEdit(false);

        navigate(
          `/Events/${Entity?.series ?? Entity?.id}/${Entity?.region}/${seriesEvent?.id}`,
          { state: { team: Entity, series: seriesEvent } },
        );
      }
    } catch (error) {
      console.error("DeleteAccount error:", error);
    } finally {
      setLoader(false);
      setisConfirmDelete(false);
    }
  };

  const handleCreateLocalStorage = (e: any) => {
    //if (e?.type === "Team") {
    //  localStorage.setItem("showTeamMemberTour", "true");
    //  return;
    //} else if
    if (
      e?.type === "PlayerOrg" &&
      e?.parent?.type === "Team" &&
      e?.subType === undefined
    ) {
      localStorage.setItem("showTeamSeasonPlayerTour", "true");
      return;
    } else if (e?.type === "Team" && e?.subType == "Club") {
      localStorage.setItem("showClubMemberTour", "true");
      return;
      //} else if (e?.type === "PlayerOrg" && e?.parent?.type === "Team") {
      //  localStorage.setItem("showClubTermMemberTour", "true");
      //  return;
    } else if (e?.type === "Club") {
      localStorage.setItem("showEliteClubMemberTour", "true");
      return;
    } else if (e?.type === "School") {
      localStorage.setItem("showSchoolStaffTour", "true");
      return;
    } else if (e?.type === "SchoolYear") {
      localStorage.setItem("showSchoolYearStudentTour", "true");
      return;
    } else if (e?.type === "Group" && e?.subType === "Department") {
      localStorage.setItem("showGroupMemberTour", "true");
      return;
    } else if (e?.type === "Group" && e?.subType === undefined) {
      localStorage.setItem("showGroupMemberTour", "true");
      return;
    } else if (e?.subType === "Class") {
      localStorage.setItem("showClassStudentTour", "true");
      return;
    } else if (e?.subType === "GradClass") {
      localStorage.setItem("showGradClassStudentTour", "true");
      return;
    } else if (e?.type === "Organization") {
      localStorage.setItem("showOrganizationEmployeeTour", "true");
      return;
    } else if (e?.type === "Neighborhood") {
      localStorage.setItem("showNeighborhoodNeighborsTour", "true");
      return;
    } else if (e?.type === "Community") {
      localStorage.setItem("showCommunityMemberTour", "true");
      return;
    } else if (e?.type === "PlayerOrg" && e?.subType === "MusicGroup") {
      localStorage.setItem("showPerformancePlayerTour", "true");
      return;
    }
  };

  const handleSaveTeam = async (e) => {
    console.log("handleSaveTeam type", type);
    console.log("handleSaveTeam Entity.type", Entity?.type);
    console.log("handleSaveTeam Entity.subType", Entity?.subType);
    e.preventDefault();
    if (isCreate) {
      //Create Team
      setIsLoading(true);
      setError("");
      let TeamType = "Team";
      if (teamType && orgFK) TeamType = teamType;
      var team: any = {
        type: TeamType,
        subType: orgFK?.type === "SchoolYear" ? "Club" : null,
        name: name,
        profile: profile,
        activity: activity,
        gender: gender,
        links: linkList,
        Preferences: {
          IsPrivate: false,
        },
      };
      dispatch(setisActive(true));

      try {
        team = await AV.AVEntity.save(team);
        handleCreateLocalStorage(team);
      } catch (error) {
        setIsLoading(false);
        setShowCreateNewPage(false);
        console.error("Error saving event:", error);
        return;
      }
      //Create season
      if (TeamType === "Team") {
        var Season: any = {
          gender: gender,
          type: "PlayerOrg",
          name: name,
          links: linkList,
          season: seasonName,
          profile: profile,
          Preferences: {
            IsPrivate: false,
          },
          team: AV.AVEntity.getLink(team),
          Parent: AV.AVEntity.getLink(team),
        };
        dispatch(setisActive(true));

        try {
          Season = await AV.AVEntity.save(Season);
          handleCreateLocalStorage(Season);
        } catch (error) {
          setIsLoading(false);
          setShowCreateNewPage(false);
          console.error("Error saving event:", error);
          return;
        }
      }
      if (orgFK) {
        await AV.Club.addTeam(
          AV.AVEntity.getFk(orgFK),
          AV.AVEntity.getFk(team),
        );
        user?.autoFollows?.unshift(AV.AVEntity.getLink(team));
        user.orgs.unshift(AV.AVEntity.getLink(team));
        dispatch(setUser(user));
        entitydatalist.push(team);
        dispatch(setEntitydata(entitydatalist));
      }
      setIsLoading(false);
      if (team && Season) {
        let child: any = AV.AVEntity.getLink(Season);
        child.title = Season?.season;
        team?.childOrgs?.push(child);
        entitydatalist?.push(team);
        entitydatalist.push(Season);
        dispatch(setEntitydata(entitydatalist));
        user?.autoFollows?.unshift(AV.AVEntity.getLink(team));
        user?.autoFollows?.unshift(AV.AVEntity.getLink(Season));
        user.orgs.unshift(child);
        user.orgs.unshift(AV.AVEntity.getLink(team));
        dispatch(setUser(user));
        //setEntity(team);
      }
      setIsLoading(false);
      if (orgFK) {
        team.parent = AV.AVEntity.getLink(orgFK);
        setPassEntity("");
      }
      let person = await AV.Person.getSelf(true);
      dispatch(setUser(person));

      const navigateEntity = TeamType === "Team" ? Season : team;
      navigate(`/teams/${navigateEntity?.id}/${navigateEntity?.region}`, {
        state: { isCreate: false, team: navigateEntity, newEntity: true },
      });

      setShowCreateNewPage(false);
    } else {
      //Update League Team
      setIsLoading(true);
      var leagueteam: AVI.IPlayerOrg = Entity;
      leagueteam.name = name;
      leagueteam.profile = profile ? profile : profile;
      leagueteam.activity = activity;
      leagueteam.season = seasonName;
      leagueteam.links = linkList;
      leagueteam.gender = gender;
      leagueteam.primaryColor = primaryColor;
      leagueteam.secondaryColor = secondaryColor;
      leagueteam.mascot = leagueteam.mascot?.id
        ? leagueteam.mascot
        : mascotImage?.id
          ? mascotImage
          : undefined;
      dispatch(setisActive(true));

      leagueteam = await AV.AVEntity.save(leagueteam);
      if (leagueteam) {
        AV.AVEntity.checkLinks(user, leagueteam).then((x) => {
          dispatch(setUser(x));
          AV.Person.checkIfSelf(x);
        });
        //let finalUser = await AV.Person.getSelf(true);
        //dispatch(setUser(finalUser));
        let index = user.orgs.findIndex((a) => a.id === leagueteam.id);
        if (index !== -1) {
          const updatedUser = { ...user };
          updatedUser.orgs = [...user.orgs];
          updatedUser.orgs[index] = {
            ...updatedUser.orgs[index],
            title: leagueteam?.name,
          };
          dispatch(setUser(updatedUser));
        }

        entitydatalist[
          entitydatalist.indexOf(
            entitydatalist?.find((x) => x?.id === leagueteam?.id),
          )
        ] = leagueteam;
        dispatch(setEntitydata(entitydatalist));
        setIsLoading(false);
        setIsShowEdit(false);
        let person = await AV.Person.getSelf(true);
        dispatch(setUser(person));

        navigate(`/teams/${leagueteam?.id}/${leagueteam?.region}`, {
          state: { isCreate: false, team: leagueteam, newEntity: true },
        });
      }
    }
  };

  const handleSaveOrg = async (e) => {
    console.log("handleSaveOrg type", type);
    console.log("handleSaveOrg Entity.type", Entity?.type);
    console.log("handleSaveOrg Entity.subType", Entity?.subType);
    e.preventDefault();
    setIsLoading(true);
    setError("");
    if (isCreate) {
      setIsLoading(true);
      //Create Club/School
      var org: any = {
        type:
          type == "Group" || type == "Department"
            ? "Group"
            : type == "Years"
              ? "SchoolYear"
              : type == "GradClass"
                ? "PlayerOrg"
                : type == "Club"
                  ? "Team"
                  : type == "EliteClub"
                    ? "Club"
                    : type == "Class" || type == "MusicGroup"
                      ? "PlayerOrg"
                      : type,
        name: name,
        profile: profile,
        location:
          type == "Class" ||
          type == "GradClass" ||
          type == "Group" ||
          type == "Department"
            ? null
            : locationoffield
              ? locationoffield
              : null,
        links: linkList,
        Preferences: {
          IsPrivate: false,
        },
      };

      if (
        type == "Class" ||
        type == "GradClass" ||
        type == "Club" ||
        type == "MusicGroup"
      ) {
        org.subType = type == "Club" ? "Club" : type;
      } else if (type === "Department") {
        org.subType = type;
      }

      if (type == "Organization") {
        org.preferences = Prefernces;
      }

      if (type == "Group" || type == "Department") {
        org.preferences = GroupType;
      }

      dispatch(setisActive(true));

      try {
        org = await AV.AVEntity.save(org);
        handleCreateLocalStorage(org);
      } catch (error) {
        setIsLoading(false);
        setShowCreateNewPage(false);
        console.error("Error saving event:", error);
        return;
      }

      if (locationaddress?.length > 0) {
        HandleLocationMap(locationaddress);
      }

      /*setEntity(org);*/
      if (org.subType == "Club") {
        var Season: any = {
          gender: gender,
          type: "PlayerOrg",
          name: name,
          links: linkList,
          subType: "Term",
          season: seasonName,
          profile: profile,
          Preferences: {
            IsPrivate: false,
          },
          team: AV.AVEntity.getLink(org),
          Parent: AV.AVEntity.getLink(org),
        };
        dispatch(setisActive(true));

        try {
          Season = await AV.AVEntity.save(Season);
          handleCreateLocalStorage(Season);
        } catch (error) {
          setIsLoading(false);
          setShowCreateNewPage(false);
          console.error("Error saving event:", error);
          return;
        }
      }

      CheckReturnValue(org);
      if (orgFK) {
        await AV.Club.addTeam(AV.AVEntity.getFk(orgFK), AV.AVEntity.getFk(org));
        org = await AV.AVEntity.get(AV.AVEntity.getFk(org));
        user?.autoFollows?.unshift(AV.AVEntity.getLink(org));
        user.orgs.unshift(AV.AVEntity.getLink(org));
        dispatch(setUser(user));
        entitydatalist.push(org);
        dispatch(setEntitydata(entitydatalist));
      }

      if (org && Season) {
        let child: any = AV.AVEntity.getLink(Season);
        child.title = Season?.season;
        org?.childOrgs?.push(child);
        entitydatalist.push(Season);
        dispatch(setEntitydata(entitydatalist));
        user?.autoFollows?.unshift(AV.AVEntity.getLink(Season));
        user.orgs.unshift(child);
        dispatch(setUser(user));
        //setEntity(team);
      }

      if (!user.orgs?.find((x: any) => x?.id == org?.id) && org?.id) {
        if (org) {
          entitydatalist.push(org);
          dispatch(setEntitydata(entitydatalist));
          user?.autoFollows?.unshift(AV.AVEntity.getLink(org));
          user.orgs.unshift(org);
          dispatch(setUser(user));
          //setEntity(org);
          //EntityDataFinding(org);
        }
      }

      if (orgFK) {
        org.parent = AV.AVEntity.getLink(orgFK);
        setPassEntity("");
      }
      let person = await AV.Person.getSelf(true);
      dispatch(setUser(person));

      navigate(`/teams/${org?.id}/${org?.region}`, {
        state: { isCreate: false, team: org, newEntity: true },
      });

      setShowCreateNewPage(false);
      //navigate(`/organizations/${ org?.id }/${ org?.region }/${ org?.type }`);
      //setIsCreate(false);
      setIsLoading(false);
    } else {
      //Update Club/School
      setIsLoading(true);
      var org = Entity;
      org.name = name;
      org.profile = profile ? profile : profile;
      org.mascot = org.mascot?.id
        ? org.mascot
        : mascotImage?.id
          ? mascotImage
          : undefined;
      org.location = locationoffield ? locationoffield : null;
      org.links = linkList;
      dispatch(setisActive(true));
      org = await AV.AVEntity.save(org);
      if (org) {
        AV.AVEntity.checkLinks(user, org).then((x) => {
          dispatch(setUser(x));
          AV.Person.checkIfSelf(x);
        });
        const index = user.orgs.findIndex((a) => a.id === org.id);
        if (index !== -1) {
          const updatedUser = { ...user };
          updatedUser.orgs = [...user.orgs];

          updatedUser.orgs[index] = {
            ...updatedUser.orgs[index],
            title: org?.name,
          };

          dispatch(setUser(updatedUser));
        }
      }

      const loc: any = await AV.Media.getMap(locationaddress);
      setgooglemap(loc);
      //await AV.Person.getSelf(true).then(( x ) =>
      //{
      // dispatch(setUser(x));
      //});
      setIsShowEdit(false);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  const validateAdoptionDate = (start: Date | null) => {
    if (!start)
      return {
        isError: true,
        message: Loc.currentLang.feeCollect.invalidDate,
      };

    const startDay = dayjs(start).startOf("day");

    if (!startDay.isValid())
      return {
        isError: true,
        message: Loc.currentLang.feeCollect.invalidDate,
      };

    return { isError: false, message: "" };
  };

  const handleAdoptionDate = (date: Dayjs | null) => {
    const newStart = date && date.isValid() ? date.toDate() : null;
    setPetAdoptionDate(newStart);
  };

  const handleSavePet = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    dispatch(setisActive(true));

    const result = validateAdoptionDate(petAdoptionDate);

    try {
      // Prepare pet entity
      let petEntity: any = isCreate
        ? {
            type: "Pet",
            name,
            petType,
            breed: petBreed,
            subBreed: petSubBreed,
            adoptionDate: result.isError ? new Date() : petAdoptionDate,
            microchipId: petMicrochipId,
            profile,
            activity,
            Preferences: { IsPrivate: false },
          }
        : {
            ...Entity,
            name,
            profile: profile || Entity.profile,
            petType,
            breed: petBreed,
            subBreed: petSubBreed,
            adoptionDate: result.isError
              ? Entity?.adoptionDate
              : petAdoptionDate,
            microchipId: petMicrochipId,
            activity,
            links: linkList,
          };

      // Save entity
      petEntity = await AV.AVEntity.save(petEntity);

      if (isCreate) {
        // Add as dependent for create
        await AV.Person.addDependent({
          id: petEntity?.id,
          type: petEntity?.type,
          name,
          email: "",
          phone: "",
        });
      } else {
        // For update, check links
        AV.AVEntity.checkLinks(user, petEntity).then((x) => {
          dispatch(setUser(x));
          AV.Person.checkIfSelf(x);
        });

        if (petEntity?.guardians?.length > 0) {
          try {
            for (const guardian of petEntity.guardians) {
              // Find parent entity
              let parentEntity =
                entitydatalist?.find((x) => x?.id === guardian.id) ?? null;

              // Fetch if not exists
              if (!parentEntity) {
                parentEntity = await AV.AVEntity.get(guardian);
                entitydatalist.push(parentEntity);
              }

              // Check links (API call)
              const result = await AV.AVEntity.checkLinks(
                parentEntity,
                petEntity,
              );

              // Update entity list
              const parentIndex = entitydatalist.findIndex(
                (x) => x?.id === guardian.id,
              );

              if (parentIndex !== -1) {
                entitydatalist[parentIndex] = result;
              }
            }

            // Redux update
            dispatch(setEntitydata([...entitydatalist]));
          } catch (error) {
            console.error("Error while checking guardian links:", error);
          }
        }
      }

      // Update entity list
      if (isCreate) {
        const person = await AV.Person.getSelf(true);
        if (person) {
          if (currentUser?.id === person?.id) dispatch(setUser(person));
          const index = entitydatalist?.findIndex((x) => x?.id === person?.id);
          if (index !== -1) {
            entitydatalist[index] = person;
            dispatch(setEntitydata(entitydatalist));
          }
        }
      } else {
        const petIndex = entitydatalist.findIndex(
          (x) => x?.id === petEntity?.id,
        );
        if (petIndex !== -1) {
          entitydatalist[petIndex] = petEntity;
          dispatch(setEntitydata(entitydatalist));
        }

        const userIndex = user.orgs.findIndex((a) => a.id === petEntity.id);
        if (userIndex !== -1) {
          const updatedUser = { ...user };
          updatedUser.orgs = [...user.orgs];
          updatedUser.orgs[userIndex] = {
            ...updatedUser.orgs[userIndex],
            title: petEntity.name,
          };
          dispatch(setUser(updatedUser));
        }

        const person = await AV.Person.getSelf(true);
        dispatch(setUser(person));
      }

      setIsShowEdit?.(false);
      setShowCreateNewPage(false);
    } catch (error) {
      console.error("Error saving pet:", error);
      setError("Failed to save pet.");
    } finally {
      setIsLoading(false);
      setShowCreateNewPage(false);
    }
  };

  const CheckReturnValue = (returnvalue: any) => {
    let oldorg = user.orgs?.find((x: any) => x?.id == returnvalue?.id);
    if (oldorg || returnvalue?.creator?.id !== user?.id) {
      let clientError = { message: Loc.currentLang.menu.orgAlreadyExists };
      CustomToast({ clientError });
      //setError();
    }
  };

  const handlePreferenceChange = (value) => {
    let updatedPreferences = {
      autoapprove: false,
      allowfollwerstopost: false,
      autoreplytopost: false,
      allowalltopost: false,
      allowmemberstopost: false,
    };

    switch (value) {
      case "Normal Group":
        updatedPreferences = {
          ...updatedPreferences,
          allowmemberstopost: true,
        };
        break;
      case "Read Only Group":
        // 'updatedPreferences' remains unchanged
        break;
      case "Public Group":
        updatedPreferences = {
          ...updatedPreferences,
          autoreplytopost: true,
          allowmemberstopost: true,
        };
        break;
      default:
        break;
    }

    setGroupType({
      ...GroupType,
      ...updatedPreferences,
      selectedPreference: value, // Update selected preference
    });
  };

  const handleUpdateEvent = async () => {
    let windowsTimeZone;
    const oldEntity = JSON.parse(JSON.stringify(Entity)); // deep clone

    if (Entity.series) {
      if (!isEditEntireSeries) {
        const isValidLink = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
        if (url) {
          if (!isValidLink?.test(url)) {
            let clientError = { message: Loc.currentLang.menu?.invalidLink };
            setIsLoading(false);
            CustomToast({ clientError }); // Display error message using CustomToast
            return; // Exit the function early if the link format is invalid
          }

          // Convert IANA to Windows Time Zone
          const ianaTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          console.log("IANA Time Zone: ", ianaTimeZone);
          windowsTimeZone = findWindows(ianaTimeZone);
          console.log("Windows Time Zone: ", windowsTimeZone);
        }

        if (!url || url?.trim()?.length == 0) {
          if (
            locationaddress?.id?.trim()?.length === 0 ||
            locationaddress?.id?.trim()?.length === undefined
          ) {
            let clientError = {
              message: Loc.currentLang.menu?.invalidLocation,
            };
            setIsLoading(false);
            CustomToast({ clientError });
            return;
          }
        }

        if (
          eventStartDate < DefaultEventDate ||
          eventEndDate < DefaultEventDate
        ) {
          let clientError = { message: Loc.currentLang.menu.invalidDate };
          setIsLoading(false);
          CustomToast({ clientError });
          return;
        }

        if (eventStartDate > eventEndDate || eventEndDate < eventStartDate) {
          let clientError = { message: Loc.currentLang.menu.invalidDate };
          setIsLoading(false);
          CustomToast({ clientError });
          return;
        }

        // Ensure EndDate does not exceed StartDate + 6 months
        const maxEndDate = new Date(eventStartDate);
        maxEndDate.setMonth(maxEndDate.getMonth() + 6);
        const formattedEndDate = new Date(eventEndDate);
        if (formattedEndDate >= maxEndDate) {
          let clientError = {
            message: Loc.currentLang.menu?.endDateLimit,
          };
          CustomToast({ clientError });
          setIsLoading(false);
          return;
        }

        const currentDateTimes = new Date();
        const eventEndDateTimes = eventEndTime;
        if (eventEndDateTimes < currentDateTimes) {
          const clientError = { message: Loc.currentLang.menu.invalidEndTime };
          CustomToast({ clientError });
          setIsLoading(false);
          return;
        }

        //Time condtion starts
        if (
          eventStartDate === eventEndDate &&
          eventStartDate === DefaultEventDate
        ) {
          const currentDateTimes = new Date();
          const eventStartTimeOnly = moment(eventStartTime).format("HH:mm:ss");
          const eventStartDateTimes = eventStartTime;
          if (eventStartDateTimes < currentDateTimes) {
            const clientError = {
              message: Loc.currentLang.menu.invalidStartTime,
            };
            CustomToast({ clientError });
            setIsLoading(false);
            return;
          }

          // Check if event end date is in the past
          const eventEndTimeOnly = moment(eventEndTime).format("HH:mm:ss");
          const eventEndDateTimes = eventEndTime;
          if (eventEndDateTimes < currentDateTimes) {
            const clientError = {
              message: Loc.currentLang.menu.invalidEndTime,
            };
            CustomToast({ clientError });
            setIsLoading(false);
            return;
          }

          // Check if event start time is after event end time
          if (eventStartTimeOnly > eventEndTimeOnly) {
            const clientError = {
              message: Loc.currentLang.menu.startTimeAfterEnd,
            };
            CustomToast({ clientError });
            setIsLoading(false);
            return;
          }

          if (eventStartTimeOnly === eventEndTimeOnly) {
            const clientError = {
              message: Loc.currentLang.menu.sameStartAndEndTime,
            };
            CustomToast({ clientError });
            setIsLoading(false);
            return;
          }

          if (Entity?.eventType == "Game") {
            if (Player >= editEventEndingTime) {
              const clientError = {
                message: Loc.currentLang.menu.invalidTeamArrival,
              };
              CustomToast({ clientError });
              setIsLoading(false);
              return;
            }
          }
        }

        if (
          eventStartDate === DefaultEventDate &&
          eventEndDate > eventStartDate
        ) {
          const currentDateTimes = new Date();
          const eventStartDateTimes = eventStartTime;
          if (eventStartDateTimes < currentDateTimes) {
            const clientError = {
              message: Loc.currentLang.menu.startInThePast,
            };
            CustomToast({ clientError });
            setIsLoading(false);
            return;
          }
        }

        if (eventStartDate === eventEndDate && eventStartTime > eventEndTime) {
          const clientError = {
            message: Loc.currentLang.menu?.invalidStartTime,
          };
          CustomToast({ clientError });
          setIsLoading(false);
          return;
        }

        if (Entity?.eventType == "Game") {
          if (
            eventTeamArrivalDate != "" &&
            (eventTeamArrivalDate > eventStartDate ||
              eventTeamArrivalDate < eventStartDate)
          ) {
            const clientError = {
              message: Loc.currentLang.menu?.arrivalDateMismatch,
            };
            CustomToast({ clientError });
            setIsLoading(false);
            return;
          }
          const currentDateTime = CurrentDateTime.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          });
          if (Playerstart > eventStartTime) {
            const clientError = {
              message: Loc.currentLang.menu?.arrivalAfterStart,
            };
            CustomToast({ clientError });
            setIsLoading(false);
            return;
          }
          if (Playerstart !== "" && Playerstart <= currentDateTime) {
            const clientError = {
              message: Loc.currentLang.menu?.arrivalInPast,
            };
            CustomToast({ clientError });
            setIsLoading(false);
            return;
          }
        }

        const eventStartTimeOnly = moment(eventStartTime).format("HH:mm:ss");
        const eventEndTimeOnly = moment(eventEndTime).format("HH:mm:ss");
        if (eventStartTimeOnly === eventEndTimeOnly) {
          const clientError = {
            message: Loc.currentLang.menu.sameStartAndEndTime,
          };
          CustomToast({ clientError });
          setIsLoading(false);
          return;
        }

        if (
          eventStartDate === DefaultEventDate &&
          eventEndDate > eventStartDate
        ) {
          const currentDateTimes = new Date();
          const eventStartTimeOnly = moment(eventStartTime).format("HH:mm:ss");
          const eventStartDateTimes = moment(
            eventStartDate + " " + eventStartTimeOnly,
          ).toDate();
          if (eventStartDateTimes < currentDateTimes) {
            const clientError = {
              message: Loc.currentLang.menu.StartInThePast,
            };
            CustomToast({ clientError });
            setIsLoading(false);
            return;
          }
        }

        const playerNew = moment(Player, "h:mm A").format("h:mm A");
        if (
          Entity?.eventType == "Game" &&
          playerNew !== "Invalid date" &&
          playerNew !== null &&
          playerNew !== ""
        ) {
          if (playerNew >= editEventEndingTime) {
            const clientError = {
              message: Loc.currentLang.menu.invalidTeamArrival,
            };
            CustomToast({ clientError });
            setIsLoading(false);
            return;
          }
        }

        setIsLoading(true);
        //var eventStartDateTime = moment(
        //  eventStartDate + " " + editEventStartingTime,
        //).toDate();
        //var eventEndDateTime = moment(
        //  eventEndDate + " " + editEventEndingTime,
        //).toDate();

        var parentFK = AV.AVEntity.getFk(Entity);
        parentFK.id = Entity.series;

        /* ---------------- BUILD SAFARI-SAFE DATES ---------------- */
        const eventStartDateTime = moment(eventStartDate)
          .hour(moment(editEventStartingTime, ["HH:mm", "h:mm A"]).hour())
          .minute(moment(editEventStartingTime, ["HH:mm", "h:mm A"]).minute())
          .second(0)
          .millisecond(0)
          .toDate();

        const eventEndDateTime = moment(eventEndDate)
          .hour(moment(editEventEndingTime, ["HH:mm", "h:mm A"]).hour())
          .minute(moment(editEventEndingTime, ["HH:mm", "h:mm A"]).minute())
          .second(0)
          .millisecond(0)
          .toDate();

        if (!seriesEvent && Entity?.seriesEvents?.length === 1) {
          seriesEvent = Entity.seriesEvents[0];
        }

        var eventSeriesEdit: AVI.IEventSeriesEdit = {
          occurId: seriesEvent.id,
          parent: parentFK,
          location: addLink ? null : locationoffield,
          url: url,
          start: eventStartDateTime,
          end: eventEndDateTime,
          links: [],
        };

        try {
          const newEvent = await AV.Event.editSeriesEvents(eventSeriesEdit);
          //Entity.Id = Entity.series;
          seriesEvent.start = new Date(eventStartDateTime).toISOString();
          seriesEvent.end = new Date(eventEndDateTime).toISOString();
          seriesEvent.location = addLink ? null : locationoffield;
          seriesEvent.URL = addLink ? url : null;
          Entity.locURL = null;
          const index = Entity.seriesEvents.findIndex(
            (x) => x.id === seriesEvent.id,
          );
          if (index !== -1) {
            Entity.seriesEvents[index] = seriesEvent;
          }
          setEntity(Entity);
          entitydatalist[
            entitydatalist.indexOf(
              entitydatalist?.find((x) => x?.id === Entity?.id),
            )
          ] = Entity;
          dispatch(setEntitydata(entitydatalist));
          let finalUser = await AV.Person.getSelf(true);
          dispatch(setUser(finalUser));

          setIsShowEdit(false);
          setIsLoading(false);
          navigate(
            `/Events/${Entity?.series}/${Entity?.region}/${seriesEvent?.id}`,
            { state: { team: Entity, series: seriesEvent } },
          );
        } catch (error) {
          console.error("Error saving event:", error);
          setIsLoading(false);
        }

        return;
      }
    }

    const isValidLink = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
    if (url) {
      if (!isValidLink?.test(url)) {
        let clientError = { message: Loc.currentLang.menu?.invalidLink };
        CustomToast({ clientError }); // Display error message using CustomToast
        return; // Exit the function early if the link format is invalid
      }

      // Convert IANA to Windows Time Zone
      const ianaTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      console.log("IANA Time Zone: ", ianaTimeZone);
      windowsTimeZone = findWindows(ianaTimeZone);
      console.log("Windows Time Zone: ", windowsTimeZone);
    }

    if (!url || url?.trim()?.length == 0) {
      if (
        locationaddress?.id?.trim()?.length === 0 ||
        locationaddress?.id?.trim()?.length === undefined
      ) {
        let clientError = { message: Loc.currentLang.menu?.invalidLocation };
        CustomToast({ clientError });
        return;
      }
    }

    let isPastMeeting = false;
    if (Entity.eventType === "Meeting" && Entity.seriesEvents?.length > 0) {
      let seletedEntity = Entity.seriesEvents?.filter((x) => x.id === seriesId);
      isPastMeeting = seletedEntity?.length > 0 ? true : false;
    }

    if (
      !isPastMeeting &&
      (eventStartDate < DefaultEventDate || eventEndDate < DefaultEventDate)
    ) {
      let clientError = { message: Loc.currentLang.menu.invalidDate };
      CustomToast({ clientError });
      return;
    }

    if (eventStartDate > eventEndDate || eventEndDate < eventStartDate) {
      let clientError = { message: Loc.currentLang.menu.invalidDate };
      CustomToast({ clientError });
      return;
    }

    // Ensure EndDate does not exceed StartDate + 6 months
    const maxEndDate = new Date(eventStartDate);
    maxEndDate.setMonth(maxEndDate.getMonth() + 6);
    const formattedEndDate = new Date(eventEndDate);
    if (formattedEndDate >= maxEndDate) {
      let clientError = {
        message: Loc.currentLang.menu?.endDateLimit,
      };
      CustomToast({ clientError });
      setIsLoading(false);
      return;
    }

    const currentDateTimes = new Date();
    const eventEndDateTimes = eventEndTime;
    if (!isPastMeeting && eventEndDateTimes < currentDateTimes) {
      const clientError = { message: Loc.currentLang.menu.invalidEndTime };
      CustomToast({ clientError });
      return;
    }

    //Time condtion starts
    if (
      eventStartDate === eventEndDate &&
      eventStartDate === DefaultEventDate
    ) {
      const currentDateTimes = new Date();
      const eventStartTimeOnly = moment(eventStartTime).format("HH:mm:ss");
      const eventStartDateTimes = eventStartTime;
      //if (eventStartDateTimes < currentDateTimes) {
      //  const clientError = { message: Loc.currentLang.menu.invalidStartTime };
      //  CustomToast({ clientError });
      //  return;
      //}

      // Check if event end date is in the past
      const eventEndTimeOnly = moment(eventEndTime).format("HH:mm:ss");
      const eventEndDateTimes = eventEndTime;
      if (eventEndDateTimes < currentDateTimes) {
        const clientError = { message: Loc.currentLang.menu.invalidEndTime };
        CustomToast({ clientError });
        return;
      }

      // Check if event start time is after event end time
      if (eventStartTimeOnly > eventEndTimeOnly) {
        const clientError = { message: Loc.currentLang.menu.startTimeAfterEnd };
        CustomToast({ clientError });
        return;
      }

      if (eventStartTimeOnly === eventEndTimeOnly) {
        const clientError = {
          message: Loc.currentLang.menu.sameStartAndEndTime,
        };
        CustomToast({ clientError });
        return;
      }

      if (Entity?.eventType == "Game") {
        if (Player >= editEventEndingTime) {
          const clientError = {
            message: Loc.currentLang.menu.invalidTeamArrival,
          };
          CustomToast({ clientError });
          return;
        }
      }
    }

    if (eventStartDate === DefaultEventDate && eventEndDate > eventStartDate) {
      const currentDateTimes = new Date();
      const eventStartDateTimes = eventStartTime;
      if (eventStartDateTimes < currentDateTimes) {
        const clientError = { message: Loc.currentLang.menu.startInThePast };
        CustomToast({ clientError });
        return;
      }
    }

    if (eventStartDate === eventEndDate && eventStartTime > eventEndTime) {
      const clientError = {
        message: Loc.currentLang.menu?.invalidStartTime,
      };
      CustomToast({ clientError });
      return;
    }

    if (Entity?.eventType == "Game") {
      if (
        eventTeamArrivalDate != "" &&
        (eventTeamArrivalDate > eventStartDate ||
          eventTeamArrivalDate < eventStartDate)
      ) {
        const clientError = {
          message: Loc.currentLang.menu?.arrivalDateMismatch,
        };
        CustomToast({ clientError });
        return;
      }

      const currentDateTime = CurrentDateTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
      if (Playerstart > eventStartTime) {
        const clientError = {
          message: Loc.currentLang.menu?.arrivalAfterStart,
        };
        CustomToast({ clientError });
        return;
      }

      if (
        Playerstart !== "" &&
        eventStartDate === DefaultEventDate &&
        Playerstart <= currentDateTime
      ) {
        const clientError = {
          message: Loc.currentLang.menu?.arrivalInPast,
        };
        CustomToast({ clientError });
        return;
      }
    }

    const eventStartTimeOnly = moment(eventStartTime).format("HH:mm:ss");
    const eventEndTimeOnly = moment(eventEndTime).format("HH:mm:ss");
    if (eventStartTimeOnly === eventEndTimeOnly) {
      const clientError = {
        message: Loc.currentLang.menu.sameStartAndEndTime,
      };
      CustomToast({ clientError });
      return;
    }

    if (eventStartDate === DefaultEventDate && eventEndDate > eventStartDate) {
      const currentDateTimes = new Date();
      const eventStartTimeOnly = moment(eventStartTime).format("HH:mm:ss");
      const eventStartDateTimes = moment(
        eventStartDate + " " + eventStartTimeOnly,
      ).toDate();
      if (eventStartDateTimes < currentDateTimes) {
        const clientError = { message: Loc.currentLang.menu.StartInThePast };
        CustomToast({ clientError });
        return;
      }
    }

    const playerNew = moment(Player, "h:mm A").format("h:mm A");
    if (
      Entity?.eventType == "Game" &&
      playerNew !== "Invalid date" &&
      playerNew !== null &&
      playerNew !== ""
    ) {
      if (playerNew >= editEventEndingTime) {
        const clientError = {
          message: Loc.currentLang.menu.invalidTeamArrival,
        };
        CustomToast({ clientError });
        return;
      }
    }

    setIsLoading(true);
    setError("");
    const formattedTeam = moment(Player, "h:mm A").format("HH:mm");
    //var eventStartDateTime = moment(
    //  eventStartDate + " " + editEventStartingTime,
    //).toDate();
    //var eventEndDateTime = moment(
    //  eventEndDate + " " + editEventEndingTime,
    //).toDate();
    //var teamarival = moment(
    //  eventTeamArrivalDate + " " + formattedTeam,
    //).toDate();
    //
    //if (Entity.eventType === "Meeting" && Entity.seriesEvents?.length > 0) {
    //  var evtStartDate = moment(Entity?.start).format("YYYY-MM-DD");
    //  var evtEndDate = moment(Entity?.end).format("YYYY-MM-DD");
    //  eventStartDateTime = moment(
    //    evtStartDate + " " + editEventStartingTime,
    //  ).toDate();
    //  eventEndDateTime = moment(
    //    evtEndDate + " " + editEventEndingTime,
    //  ).toDate();
    //}

    /* ---------------- BUILD SAFARI-SAFE DATES ---------------- */
    const startTime = moment(editEventStartingTime, ["HH:mm", "h:mm A"]);
    const endTime = moment(editEventEndingTime, ["HH:mm", "h:mm A"]);
    const arrivalTime = moment(formattedTeam, ["HH:mm", "h:mm A"]);

    let eventStartDateTime = moment(eventStartDate)
      .hour(startTime.hour())
      .minute(startTime.minute())
      .second(0)
      .millisecond(0)
      .toDate();

    let eventEndDateTime = moment(eventEndDate)
      .hour(endTime.hour())
      .minute(endTime.minute())
      .second(0)
      .millisecond(0)
      .toDate();

    let teamarival: Date | null = null;
    if (formattedTeam && eventTeamArrivalDate) {
      teamarival = moment(eventTeamArrivalDate)
        .hour(arrivalTime.hour())
        .minute(arrivalTime.minute())
        .second(0)
        .millisecond(0)
        .toDate();
    }

    if (Entity.eventType === "Meeting" && Entity.seriesEvents?.length > 0) {
      const evtStartBase = moment(Entity.start);
      const evtEndBase = moment(Entity.end);

      eventStartDateTime = evtStartBase
        .hour(startTime.hour())
        .minute(startTime.minute())
        .second(0)
        .millisecond(0)
        .toDate();

      eventEndDateTime = evtEndBase
        .hour(endTime.hour())
        .minute(endTime.minute())
        .second(0)
        .millisecond(0)
        .toDate();
    }

    Entity.name = name;
    //Entity.location = locationoffield?.id ? locationoffield :null;
    Entity.profile = profile;
    Entity.start = eventStartDateTime;
    Entity.end = eventEndDateTime;
    Entity.locURL = url;
    Entity.tz = url ? (windowsTimeZone?.toLocaleString() ?? null) : null;
    Entity.location = addLink ? null : locationoffield;
    Entity.links = linkList;

    //if (url) {
    // Entity.tz = url ? windowsTimeZone?.toLocaleString() ?? null : null;
    //}

    console.log(Links);
    Entity.playerStart = teamarival;
    dispatch(setisActive(true));

    try {
      let val = await AV.AVEntity.save(Entity);
      if (val) {
        setEntity(val);
        let finalUser = await AV.Person.getSelf(true);
        dispatch(setUser(finalUser));
        let index = entitydatalist?.findIndex((x) => x?.id === finalUser?.id);
        if (index != -1) {
          entitydatalist[index] = finalUser;
          dispatch(setEntitydata(entitydatalist));
        }

        //AV.AVEntity.checkLinks(currentUser, val);

        if (val?.parent) {
          try {
            let parentEntity =
              entitydatalist?.find((x) => x?.id === val.parent.id) ?? null;

            //if (!parentEntity) {
            //  parentEntity = await AV.AVEntity.get(val.parent);
            //  entitydatalist?.push(parentEntity);
            //  dispatch(setEntitydata(entitydatalist));
            //}

            const newEntity = await AV.AVEntity.get(val.parent);
            if (!parentEntity) {
              parentEntity = newEntity;
              entitydatalist?.push(newEntity);
              dispatch(setEntitydata(entitydatalist));
            } else {
              parentEntity = newEntity;
              let index = entitydatalist?.findIndex(
                (x) => x?.id === parentEntity?.id,
              );
              if (index != -1) {
                entitydatalist[index] = newEntity;
                dispatch(setEntitydata(entitydatalist));
              }
            }

            const result = await AV.AVEntity.checkLinks(parentEntity, val);

            entitydatalist[
              entitydatalist.indexOf(
                entitydatalist?.find((x) => x?.id === val?.parent?.id),
              )
            ] = result;
            dispatch(setEntitydata(entitydatalist));

            if (val?.parent?.type === "Person") {
              dispatch(setUser(result));
            }
          } catch (error) {
            console.error("Error while checking entity links:", error);
          }
        }

        const loc = await AV.Media.getMap(locationaddress);
        setgooglemap(loc);
        setIsShowEdit(false);
        setIsLoading(false);

        let newSeriesId =
          val?.seriesEvents !== undefined && val?.seriesEvents?.length > 0
            ? val?.seriesEvents[0].id
            : "undefined";
        navigate(`/Events/${val?.id}/${val?.region}/${newSeriesId}`, {
          state: { team: val, series: val?.seriesEvents },
        });

        return;
      }

      const loc = await AV.Media.getMap(locationaddress);
      setgooglemap(loc);
      setIsShowEdit(false);
      setIsLoading(false);
    } catch (error) {
      console.error("Error saving event:", error);
      setEntity(oldEntity);
      setIsLoading(false);
    }
  };

  const handleUpdateFeeCollect = async () => {
    setIsLoading(true);
    // ---- VALIDATION ----
    if (!name.trim()) {
      let clientError = {
        message: Loc.currentLang.feeCollect.errorTitleRequired,
      };
      CustomToast({ clientError });
      setIsLoading(false);
      return;
    }

    const result = validateCollectDates(collectStartDate, collectEndDate);
    if (result.isError) {
      let clientError = { message: result.message };
      CustomToast({ clientError });
      setIsLoading(false);
      return;
    }

    // Convert IANA to Windows Time Zone
    let windowsTimeZone;
    const ianaTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log("IANA Time Zone: ", ianaTimeZone);
    windowsTimeZone = findWindows(ianaTimeZone);
    console.log("Windows Time Zone: ", windowsTimeZone);

    Entity.name = name.trim();
    Entity.profile = profile;
    Entity.start = collectStartDate;
    Entity.end = collectEndDate;
    Entity.tz = url ? (windowsTimeZone?.toLocaleString() ?? null) : null;
    dispatch(setisActive(true));

    try {
      let val = await AV.AVEntity.save(Entity);
      if (val) {
        setEntity(val);
        let finalUser = await AV.Person.getSelf(true);
        dispatch(setUser(finalUser));
        let index = entitydatalist?.findIndex((x) => x?.id === finalUser?.id);
        if (index != -1) {
          entitydatalist[index] = finalUser;
          dispatch(setEntitydata(entitydatalist));
        }
      }

      setIsShowEdit(false);
      setIsLoading(false);
    } catch (error) {
      console.error("Error saving event:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setRefreshTimeKey((prevKey) => prevKey + 1);
  }, [triggerEndDate]);

  useEffect(() => {
    setProfile(Entity?.profile);
  }, [Entity?.profile]);

  useEffect(() => {
    setRefreshKey((prevKey) => prevKey + 1);
  }, [triggerStartTime]);

  useEffect(() => {
    let isMounted = true;
    const fetch = async () => {
      let ActivityType = await AV.Team.getActivites();
      console.log("All the Activites with LOC:::", ActivityType);
      setactivitytypelist(ActivityType);
    };

    if (isMounted) {
      let gendertype = Loc.currentLang.gender;
      setName("");
      setDescription("");
      setActivity("");
      setActivityLoc("");
      setSeasonName("");
      setGender("");
      setLinks("");
      setlocationaddress([]);
      setEventLocation("");
      if (gendertype) {
        const objectArray: any = Object.entries(gendertype).map(
          ([key, value]) => ({ key, value }),
        );
        console.log("Object Array:::::::", objectArray);
        setgendertypelist(objectArray);
        setGender(objectArray[2].value);
      }
      fetch();
    }

    return () => {
      isMounted = false; // Set the flag to false when the component is unmounted
      // Cancel subscriptions or perform any cleanup tasks here
    };
  }, [isCreate, type]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setName(Entity?.name ? Entity?.name : "");
      setDescription(Entity?.profile?.text ? Entity?.profile?.text : "");
      setActivity(Entity?.activity ? Entity?.activity : "");
      setActivityLoc(
        Entity?.activity
          ? activitytypelist?.filter((x) => (x.name = Entity?.activity)).loc
          : "",
      );
      console.log(
        "ActivityLoc::::::::::::::::::::::::::::::::",
        activitytypelist?.filter((x) => (x.name = Entity?.activity)).loc,
      );
      setSeasonName(Entity?.season ? Entity?.season : "");
      setGender(Entity?.gender ? Entity?.gender : "Any");
      setLinks(Entity?.links ? Entity?.links : "");
      setLinksList(Entity?.links ? Entity?.links : []);
      setEventStartDate(
        seriesEvent
          ? seriesEvent?.start
            ? moment(seriesEvent?.start).format("YYYY-MM-DD")
            : ""
          : Entity?.start
            ? moment(Entity?.start).format("YYYY-MM-DD")
            : "",
      );
      setEventEndDate(
        seriesEvent
          ? seriesEvent?.end
            ? moment(seriesEvent?.end).format("YYYY-MM-DD")
            : ""
          : Entity?.end
            ? moment(Entity?.end).format("YYYY-MM-DD")
            : "",
      );
      setEventStartTime(
        seriesEvent
          ? seriesEvent?.start
            ? seriesEvent?.start
            : ""
          : Entity?.start
            ? Entity?.start
            : "",
      );
      setEventEndTime(
        seriesEvent
          ? seriesEvent?.end
            ? seriesEvent?.end
            : ""
          : Entity?.end
            ? Entity?.end
            : "",
      );
      SetStartingTime(
        seriesEvent
          ? seriesEvent?.start
            ? moment(seriesEvent?.start).format("hh:mm A")
            : ""
          : Entity?.start
            ? moment(Entity?.start).format("hh:mm A")
            : "",
      );
      setPlayer(
        Entity?.playerStart
          ? moment(Entity?.playerStart).format("hh:mm A")
          : "",
      );
      setEndingTime(
        seriesEvent
          ? Entity?.end
            ? moment(Entity?.end).format("hh:mm A")
            : ""
          : Entity?.end
            ? moment(Entity?.end).format("hh:mm A")
            : "",
      );
      setlocationaddress(
        seriesEvent?.location
          ? seriesEvent?.location
          : Entity?.location
            ? Entity?.location
            : "",
      );
      setEventLocation(
        seriesEvent?.location?.normalized
          ? seriesEvent?.location?.normalized
          : Entity?.location?.normalized
            ? Entity?.location?.normalized
            : "",
      );
      setIsFieldsName(
        seriesEvent?.location?.field
          ? seriesEvent?.location?.field
          : Entity?.location?.field,
      );
      setFieldValue(
        seriesEvent?.location?.field?.name
          ? seriesEvent?.location?.field?.name
          : Entity?.location?.field?.name
            ? Entity?.location?.field?.name
            : Loc.currentLang.menu.fields,
      );
      setIsMapField(
        seriesEvent?.location?.field?.name
          ? seriesEvent?.location?.field?.name
          : Entity?.location?.field?.name
            ? Entity?.location?.field?.name
            : "",
      );
      setUrl(
        seriesEvent?.locURL
          ? seriesEvent.locURL
          : Entity?.locURL
            ? Entity?.locURL
            : "",
      );
      setAddLink(seriesEvent?.locURL ? true : Entity?.locURL ? true : false);

      setPetType(Entity?.petType ?? "");
      setPetBreed(Entity?.breed ?? "");
      setPetSubBreed(Entity?.subBreed ?? "");
      setPetAdoptionDate(Entity?.adoptionDate ?? new Date());
      setPetMicrochipId(Entity?.microchipId ?? "");
    }
    return () => {
      isMounted = false; // Set the flag to false when the component is unmounted
      // Cancel subscriptions or perform any cleanup tasks here
    };
  }, [isShowEdit]);

  // Create button disable condition
  const isCreateDisabled = (() => {
    // Default: name is required for all entity types
    if (!name?.trim()) return true;

    if (Entity?.type === "Team" && isShowEdit) return false;

    switch (true) {
      // Pet
      case type === "Pet":
        return !petType?.trim() || !petBreed?.trim();

      // Team or Club require seasonName
      case //!isShowEdit &&
      (type === "Team" && Entity?.subType !== "Club") ||
        (Entity?.type === "PlayerOrg" &&
          (Entity?.subType === "Term" || Entity?.season?.length > 0)) ||
        (type === "Club" && !Entity):
        return !seasonName?.trim();

      //// Collect
      //case type === "Collect" || Entity?.type === "Collect":
      //  return isCollectDateError;

      // Event
      case Entity?.type === "Event":
        if (!addLink) {
          return (
            !eventLocation?.trim() ||
            !isValidStartDate ||
            !isValidEndDate ||
            !isValidStartTime ||
            !isValidEndTime
          );
        }
        return addLink
          ? url?.trim()?.length === 0
          : !isValidStartDate ||
              !isValidEndDate ||
              !isValidStartTime ||
              !isValidEndTime;

      // Default = not disabled
      default:
        return false;
    }
  })();

  // Create button onPress action
  const handleCreateAction =
    ((type === "Team" && Entity?.subType !== "Club") || type === "PlayerOrg") &&
    //Entity?.subType !== "Term" &&
    Entity?.subType !== "Class" &&
    Entity?.subType !== "GradClass" &&
    Entity?.subType !== "MusicGroup"
      ? handleSaveTeam
      : Entity?.type === "Event"
        ? handleUpdateEvent
        : type === "Pet"
          ? handleSavePet
          : type === "Collect"
            ? handleUpdateFeeCollect
            : handleSaveOrg;

  return (
    <>
      <VStack
        width={"100%"}
        top={
          Entity?.type === "Event"
            ? "93px"
            : isShowEdit && Entity?.type === "Pet"
              ? "0px"
              : "24px"
        }
        borderRadius={"10px"}
        zIndex={-3}
        height={"auto"}
        marginBottom={Entity?.type === "Event" ? "120px" : "40px"}
      >
        {/*Create and Cancel Button*/}
        <HStack
          justifyContent={isMobile ? "flex-end" : "flex-end"}
          space={"12px"}
          marginLeft={isMobile ? "12px" : ""}
          marginRight={isMobile ? "12px" : "24px"}
          width={"auto"}
          zIndex={-3}
        >
          <Offline>
            {({ isOffline }) => (
              <Button
                isDisabled={isOffline}
                background={"#EEEEEE"}
                width={isMobile ? "100px" : "120px"}
                height={"40px"}
                rounded="full"
                onPress={() => {
                  if (isMobile) {
                    navigate(-1);
                  } else if (isShowEdit && type !== "Pet") {
                    setIsShowEdit(false);
                  } else if (isShowEdit && type === "Pet") {
                    setIsShowEdit(false);
                    setShowCreateNewPage(false);
                  } else {
                    setShowCreateNewPage(false);
                  }
                }}
              >
                <Text color={"rgba(0, 0, 0, 0.50)"} fontWeight={500}>
                  {Loc.currentLang.menu.cancel}
                </Text>
              </Button>
            )}
          </Offline>

          {Entity?.type == "Event" && new Date(eventEndTime) > new Date() && (
            <>
              {Entity?.status === "Canceled" ? (
                <Offline>
                  {({ isOffline }) => (
                    <Button
                      isDisabled={isOffline}
                      background={"#EEEEEE"}
                      width={isMobile ? "100px" : "122px"}
                      height={"40px"}
                      rounded="full"
                      isLoading={deleteLoader}
                      onPress={handleUncancelEvent}
                    >
                      <Text color={"rgba(0, 0, 0, 0.50)"} fontWeight={500}>
                        {Loc.currentLang?.alertType?.unCancelEvent ??
                          " Un-Cancel Event"}
                      </Text>
                    </Button>
                  )}
                </Offline>
              ) : (
                <Offline>
                  {({ isOffline }) => (
                    <Button
                      isDisabled={isOffline}
                      background={"#EEEEEE"}
                      width={isMobile ? "100px" : "120px"}
                      height={"40px"}
                      rounded="full"
                      isLoading={deleteLoader}
                      onPress={handleDeleteEvent}
                    >
                      <Text color={"rgba(0, 0, 0, 0.50)"} fontWeight={500}>
                        {Loc.currentLang.alertType.cancelEvent}
                      </Text>
                    </Button>
                  )}
                </Offline>
              )}
            </>
          )}

          <Offline>
            {({ isOffline }) => (
              <Button
                bgColor={"#32AE78"}
                width={isMobile ? "100px" : "120px"}
                height={"40px"}
                rounded="full"
                isLoading={isLoading}
                isDisabled={isOffline || isCreateDisabled}
                onPress={handleCreateAction}
              >
                <Text color={"#ffffff"} fontWeight={500}>
                  {isShowEdit
                    ? Loc.currentLang.menu.update
                    : Loc.currentLang.menu.create}
                </Text>
              </Button>
            )}
          </Offline>
        </HStack>

        {/* Help Text */}
        {(Entity?.type === "Pet" ||
          (Entity?.type !== "Event" && !isShowEdit)) && (
          <HStack
            marginLeft="24px"
            marginRight="24px"
            marginY="30px"
            width="auto"
            space={3}
            zIndex={-3}
          >
            <HStack>
              <HelpIcon height="24" width="24" color="black" />
            </HStack>
            <HStack width="95%">
              {(() => {
                const typeKey = type || teamValue;

                const helpTextMap: Record<string, string> = {
                  Team: Loc.currentLang.helpText.createNew.team,
                  Club: Loc.currentLang.helpText.createNew.club,
                  EliteClub: Loc.currentLang.helpText.createNew.eliteClub,
                  School: Loc.currentLang.helpText.createNew.school,
                  Group: Loc.currentLang.helpText.createNew.group,
                  Class: Loc.currentLang.helpText.createNew.class,
                  MusicGroup:
                    Loc.currentLang.helpText.createNew.performanceGroup,
                  GradClass: Loc.currentLang.helpText.createNew.gradClass,
                  Organization: Loc.currentLang.helpText.createNew.organization,
                  Neighborhood: Loc.currentLang.helpText.createNew.neighborHood,
                  Community: Loc.currentLang.helpText.createNew.community,
                  Pet: Loc.currentLang.helpText.createNew.pet,
                  Years: Loc.currentLang.helpText.createNew.years,
                  Department: Loc.currentLang.helpText.createNew.department,
                };

                return helpTextMap[typeKey] ? (
                  <Text>{helpTextMap[typeKey]}</Text>
                ) : null;
              })()}
            </HStack>
          </HStack>
        )}

        <VStack
          marginX={"24px"}
          space={"34px"}
          marginTop={Entity?.type == "Event" || isShowEdit ? "24px" : ""}
          zIndex={-3}
        >
          {/*Team Name + Season Input*/}
          {(() => {
            const showSeasonInput =
              (isCreate &&
                (type === "Team" || type === "Club") &&
                Entity?.subType == undefined) ||
              (isShowEdit &&
                type === "PlayerOrg" &&
                Entity?.subType !== "Class" &&
                Entity?.subType !== "MusicGroup" &&
                Entity?.subType !== "GradClass");

            const nameBoxWidth =
              (isCreate &&
                !isMobile &&
                (type === "Team" || type === "Club") &&
                Entity?.subType == undefined) ||
              (isShowEdit &&
                type === "PlayerOrg" &&
                Entity?.subType !== "MusicGroup" &&
                Entity?.subType !== "Class" &&
                Entity?.subType !== "GradClass")
                ? "48%"
                : isCreate && isMobile
                  ? "100%"
                  : "100%";

            const seasonBoxWidth = isCreate && isMobile ? "100%" : "48%";

            return (
              <HStack width={"100%"} space={"4%"} flexWrap={"wrap"}>
                {/*Team Name input*/}
                <Box width={nameBoxWidth} marginBottom={isMobile ? "24px" : ""}>
                  <AVInputtext
                    type="text"
                    label={
                      Entity?.type === "Event"
                        ? Loc.currentLang.menu.eventTitle
                        : Entity?.type === "Collect"
                          ? Loc.currentLang.feeCollect.title
                          : Loc.currentLang.menu.nameReq
                    }
                    maxLength={50}
                    onChange={HandleName}
                    value={name}
                    disabled={
                      Entity?.type === "Event" &&
                      Entity?.series &&
                      !isEditEntireSeries
                    }
                  />
                </Box>

                {/*Season Input*/}
                {showSeasonInput && (
                  <Box width={seasonBoxWidth}>
                    <AVInputtext
                      type="text"
                      label={
                        (type === "PlayerOrg" || teamValue === "Team") &&
                        Entity?.subType !== "Term"
                          ? Loc.currentLang.menu.seasonReq
                          : Loc.currentLang.menu.termName
                      }
                      maxLength={50}
                      onChange={HandleSeasonName}
                      value={seasonName}
                    />
                  </Box>
                )}
              </HStack>
            );
          })()}

          {/* Event date + time pickers */}
          {Entity?.type == "Event" && (
            <HStack space={2} width={"100%"}>
              {/* Start Date */}
              <Box flex={1}>
                <Box width={"100%"} marginTop={"-8px"}>
                  <AVDatePicker
                    key={`end-date-picker-${refreshKey}`}
                    label={
                      (Entity?.eventType === "Meeting" ||
                        Entity?.eventType === "Meeting") &&
                      !isShowEdit
                        ? "Reoccurance start date *"
                        : Loc.currentLang.menu.startDate
                    }
                    onChange={handleEventStartDate}
                    defaultValue={dayjs(eventStartDate)}
                    disable={isEditEntireSeries}
                  />
                </Box>
              </Box>

              {/* Start Time */}
              <Box flex={1}>
                <Box width={"100%"} marginTop={"-8px"}>
                  <AVTimePicker
                    key={`start-time-picker-${refreshTimeKey}`}
                    label={Loc.currentLang.menu.startTime}
                    onChange={handleEventStartTime}
                    defaultValue={dayjs(eventStartTime)}
                    disable={false}
                  />
                </Box>
              </Box>
            </HStack>
          )}

          {/* Team Arrival Time  && Team Arrival Date*/}
          {Entity?.type === "Event" && Entity?.eventType === "Game" && (
            <HStack>
              {/* Team Arrival Time */}
              <Box flex={1} marginTop="-8px">
                <AVTimePicker
                  label={Loc.currentLang.menu.teamArivalTime}
                  onChange={handleEventTeamArival}
                  defaultValue={Playerstart ? dayjs(Playerstart) : null}
                  disable={isEditEntireSeries}
                />
              </Box>

              {/* Team Arrival Date */}
              <Box flex={1}>
                <AVDatePicker
                  label={Loc.currentLang.menu.teamArrivalDate}
                  onChange={handleEventTeamArrival}
                  defaultValue={
                    eventTeamArrivalDate ? dayjs(eventTeamArrivalDate) : null
                  }
                  disable={isEditEntireSeries}
                />
              </Box>
            </HStack>
          )}

          {/* Event End Date && Event End Time */}
          {Entity?.type === "Event" && (
            <HStack space={2} width="100%">
              {/* Event End Date */}
              <Box flex={1} marginTop="-8px">
                <AVDatePicker
                  key={`end-date-picker-${refreshTimeKey}`}
                  label={
                    Entity?.eventType === "Meeting" && !isShowEdit
                      ? "Reoccurrence end date *"
                      : Loc.currentLang.menu.endDate
                  }
                  onChange={handleEventEndDate}
                  defaultValue={dayjs(eventEndDate)}
                  disable={isEditEntireSeries}
                />
              </Box>

              {/* Event End Time */}
              <Box flex={1} marginTop="-8px">
                <AVTimePicker
                  key={`end-time-picker-${refreshKey}`}
                  label={Loc.currentLang.menu.endTime}
                  onChange={handleEventEndTime}
                  defaultValue={dayjs(eventEndTime)}
                  disable={false}
                />
              </Box>
            </HStack>
          )}

          {/* Type and Gender */}
          {(type === "Team" && Entity?.subType === undefined) ||
          (type === "PlayerOrg" &&
            !["Class", "MusicGroup", "Term", "GradClass"].includes(
              Entity?.subType || "",
            )) ? (
            <HStack
              width="100%"
              flexWrap="wrap"
              space="4%"
              zIndex={addLinkPopup ? undefined : 999}
            >
              {/* Activity Type (Team only) */}
              {type === "Team" && (
                <HStack
                  zIndex={addLinkPopup ? undefined : 999}
                  width={isMobile && isCreate ? "100%" : "48%"}
                  marginBottom={isMobile ? "24px" : ""}
                  space={3}
                >
                  <AVDropdown
                    defaultValue={
                      activity ? { value: activity, label: activity } : null
                    }
                    value={
                      activity
                        ? {
                            value: activity,
                            label: activitytypelist?.find(
                              (x) =>
                                x.name.toLowerCase() === activity.toLowerCase(),
                            )?.loc,
                          }
                        : null
                    }
                    options={activitytypelist?.map((option) => ({
                      value: option?.name,
                      label: option?.loc,
                    }))}
                    isSearchable
                    noOptionsMessage={() => null}
                    components={{ dropdownIndicator }}
                    onChange={HandleActivity}
                  />
                </HStack>
              )}

              {/* Gender Selection */}
              {(type === "Team" && Entity?.subType === undefined) ||
              (type === "PlayerOrg" && Entity?.subType === undefined) ? (
                <HStack
                  width={
                    type === "PlayerOrg" ||
                    (type === "Team" && isMobile && isCreate)
                      ? "100%"
                      : "48%"
                  }
                  zIndex={-3}
                  top={isMobile && isCreate ? "10px" : undefined}
                >
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      {Loc.currentLang.menu.gender}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={gender}
                      label={Loc.currentLang.menu.gender}
                      onChange={HandleGender}
                    >
                      {gendertypelist?.map((option) => (
                        <MenuItem key={option?.value} value={option?.value}>
                          {option?.value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </HStack>
              ) : null}
            </HStack>
          ) : null}

          {/* Collect Start & End Date */}
          {Entity?.type === "Collect" && (
            <HStack space={2} width="100%">
              <Box flex={1} marginTop="-8px">
                <AVDatePicker
                  key={`end-date-picker-${refreshTimeKey}`}
                  label={Loc.currentLang.menu.startDate}
                  onChange={handleCollectStartDate}
                  defaultValue={dayjs(collectStartDate)}
                  disable={false}
                />
              </Box>

              <Box flex={1} marginTop="-8px">
                <AVDatePicker
                  key={`end-date-picker-${refreshTimeKey}`}
                  label={Loc.currentLang.menu.endDate}
                  onChange={handleCollectEndDate}
                  defaultValue={dayjs(collectEndDate)}
                  disable={false}
                />
              </Box>
            </HStack>
          )}

          {/*Description Input*/}
          {(seriesEvent == null ||
            seriesEvent == undefined ||
            seriesEvent == "") && (
            <HStack zIndex={-3}>
              <Box width={"100%"}>
                <AVInputtext
                  type={"text"}
                  minRows="5"
                  size="medium"
                  multiline={true}
                  maxLength={250}
                  onChange={handleIntroText}
                  defaultValue={undefined}
                  width={undefined}
                  value={description}
                  height={"60px"}
                  label={Loc.currentLang.placeholderText.personalDescription}
                  placeholder={undefined}
                />
              </Box>
            </HStack>
          )}

          {/*Pet TYpe && Breed */}
          {(isCreate || isShowEdit) && type === "Pet" && (
            <HStack width={"100%"} space={"4%"} flexWrap={"wrap"}>
              {/*PetType Input*/}
              <Box width={"48%"} marginBottom={isMobile ? "24px" : ""}>
                <AVInputtext
                  type={"text"}
                  label={Loc.currentLang.menu.petType}
                  maxLength={50}
                  onChange={(e) => setPetType(e?.target?.value)}
                  defaultValue={undefined}
                  width={undefined}
                  value={petType}
                  height={undefined}
                  minRows={undefined}
                  multiline={undefined}
                  size={undefined}
                  placeholder={undefined}
                  disabled={false}
                />
              </Box>

              {/*Breed Input*/}
              <Box
                width={(isCreate || isShowEdit) && isMobile ? "100%" : "48%"}
              >
                <AVInputtext
                  type={"text"}
                  label={Loc.currentLang.menu.petBreed}
                  maxLength={50}
                  onChange={(e) => setPetBreed(e?.target?.value)}
                  defaultValue={undefined}
                  width={undefined}
                  value={petBreed}
                  height={undefined}
                  minRows={undefined}
                  multiline={undefined}
                  size={undefined}
                  placeholder={undefined}
                />
              </Box>
            </HStack>
          )}

          {/*Pet Sub Breed, Adoption Date && Microchip Id */}
          {(isCreate || isShowEdit) && type === "Pet" && (
            <HStack space={4} width="100%">
              <Box flex={1}>
                <AVInputtext
                  type={"text"}
                  label={Loc.currentLang.menu.petSubBreed}
                  maxLength={50}
                  onChange={(e) => setPetSubBreed(e?.target?.value)}
                  defaultValue={undefined}
                  width={undefined}
                  value={petSubBreed}
                  height={undefined}
                  minRows={undefined}
                  multiline={undefined}
                  size={undefined}
                  placeholder={undefined}
                  disabled={false}
                />
              </Box>

              <Box flex={1} marginTop="-8px">
                <AVDatePicker
                  key={`adoption-date-picker-${refreshKey}`}
                  label={Loc.currentLang.menu.petAdoptionDate}
                  onChange={handleAdoptionDate}
                  defaultValue={dayjs(petAdoptionDate)}
                  disable={false}
                  type={"Pet"}
                />
              </Box>

              <Box flex={1}>
                <AVInputtext
                  type={"text"}
                  label={Loc.currentLang.menu.petMicrochipId}
                  maxLength={50}
                  onChange={(e) => setPetMicrochipId(e?.target?.value)}
                  defaultValue={undefined}
                  width={undefined}
                  value={petMicrochipId}
                  height={undefined}
                  minRows={undefined}
                  multiline={undefined}
                  size={undefined}
                  placeholder={undefined}
                />
              </Box>
            </HStack>
          )}

          {Entity?.type === "Event" && (
            /*CheckBox*/
            <Box>
              <Stack
                direction={{
                  base: "row",
                  md: "row",
                }}
                space={"35px"}
                alignItems="flex-start"
                zIndex={-2}
              >
                <Checkbox
                  size="sm"
                  zIndex={-2}
                  isChecked={addLink}
                  onChange={() => {
                    setAddLink(!addLink);
                    setEventLocation("");
                    setlocationaddress([]);
                    setlocationaddress([]);
                    setUrl("");
                    setVisibleField(false);
                  }}
                  value={""}
                >
                  {Loc.currentLang.menu.onlineEvent}
                </Checkbox>
              </Stack>
            </Box>
          )}

          {/*UrlInput*/}
          {addLink && (
            <Box width={"100%"}>
              <AVInputtext
                type={"text"}
                label={`${Loc.currentLang.menu.eventUrl} *`}
                onChange={handleEventUrl}
                value={url}
                maxLength={500}
                defaultValue={undefined}
                width={undefined}
                height={undefined}
                minRows={undefined}
                multiline={undefined}
                size={undefined}
                placeholder={undefined}
              />
            </Box>
          )}

          {addLink && !isValidUrl && (
            <View top="-8">
              <Text pt="3" bold>
                Example: http://www.example.com or http://example.com or
                https://example.com
              </Text>
            </View>
          )}

          {/*Location Box*/}
          {addLink ||
            (((type !== "Team" ||
              Entity?.subType == "Term" ||
              Entity?.type == "Club") &&
            type !== "PlayerOrg" &&
            type !== "Group" &&
            Entity?.type == "Club"
              ? type == "Club"
              : type !== "Club" &&
                type !== "Class" &&
                type !== "MusicGroup" &&
                type !== "GradClass" &&
                type !== "Team" &&
                Entity?.subType != "Club" &&
                type !== "Group" &&
                Entity?.type !== "PlayerOrg" &&
                type !== "Pet" &&
                type !== "Years" &&
                type !== "SchoolYear" &&
                Entity?.Type !== "SchoolYear" &&
                type !== "Department" &&
                Entity?.subType !== "Department" &&
                Entity?.type !== "Collect") && (
              <VStack space={"24px"}>
                <AVLocationBox
                  locationaddress={locationaddress}
                  seriesEvent={seriesEvent}
                  setlocationaddress={setlocationaddress}
                  setSiteField={undefined}
                  visiblefield={visiblefield}
                  setVisibleField={setVisibleField}
                  isCreate={isCreate}
                  setEventLocation={setEventLocation}
                  eventLocation={eventLocation}
                  isShowEdit={isShowEdit}
                  Entity={Entity}
                  handleupdatelocationfield={handleupdatelocationfield}
                  isGame={undefined}
                  isPractice={undefined}
                  setLocationEntity={setLocationEntity}
                  locationEntity={locationEntity}
                  mapField={mapField}
                  setIsMapField={setIsMapField}
                  isCreateevent={undefined}
                  isFieldsName={isFieldsName}
                  setIsFieldsName={setIsFieldsName}
                />
              </VStack>
            ))}

          {/* Group and Organization Preferences */}
          {(type === "Group" || type === "Organization") && !isShowEdit && (
            <VStack zIndex={-2}>
              {/* Organization-specific settings */}
              {type === "Organization" && (
                <VStack>
                  {/* Auto Approve */}
                  <HStack
                    marginTop="20px"
                    width={isMobile ? "91%" : "70%"}
                    marginLeft={isMobile ? "26px" : "45px"}
                    space="70px"
                    zIndex={-2}
                  >
                    <Text
                      width={isMobile ? "41%" : "33%"}
                      textAlign="left"
                      fontSize="18px"
                      numberOfLines={2}
                      ellipsizeMode="tail"
                    >
                      {Loc.currentLang.menu.autoApprove}
                    </Text>

                    <Radio.Group
                      name="autoApproveGroup"
                      defaultValue={Prefernces?.autoFollow ? "true" : "false"}
                      accessibilityLabel="pick a size"
                      onChange={() =>
                        setPrefernces((prefs) => ({
                          ...prefs,
                          autoFollow: !Prefernces?.autoFollow,
                        }))
                      }
                    >
                      <Stack
                        direction={{ base: "column", md: "row" }}
                        alignItems={{ base: "flex-start", md: "center" }}
                        space="65px"
                        w="75%"
                        maxW="300px"
                      >
                        <Radio value="true" size="sm" my={1} fontSize="18px">
                          {Loc.currentLang.menu.yes}
                        </Radio>
                        <Radio value="false" size="sm" my={1} fontSize="18px">
                          {Loc.currentLang.menu.no}
                        </Radio>
                      </Stack>
                    </Radio.Group>
                  </HStack>

                  <Divider
                    marginY="20px"
                    marginLeft="28px"
                    width={isMobile ? "85%" : "93%"}
                    zIndex={-1}
                  />

                  {/* Allow Followers */}
                  <HStack
                    marginTop="20px"
                    width={isMobile ? "91%" : "70%"}
                    marginLeft={isMobile ? "26px" : "45px"}
                    space="70px"
                    zIndex={-2}
                  >
                    <Text
                      width={isMobile ? "41%" : "33%"}
                      textAlign="left"
                      fontSize="18px"
                      numberOfLines={2}
                      ellipsizeMode="tail"
                    >
                      {Loc.currentLang.menu.allowFollowers}
                    </Text>

                    <Radio.Group
                      name="allowFollowersGroup"
                      defaultValue={
                        Prefernces?.allowFollowersPosts ? "true" : "false"
                      }
                      accessibilityLabel="pick a size"
                      onChange={() =>
                        setPrefernces((prefs) => ({
                          ...prefs,
                          allowFollowersPosts: !Prefernces?.allowFollowersPosts,
                        }))
                      }
                    >
                      <Stack
                        direction={{ base: "column", md: "row" }}
                        alignItems={{ base: "flex-start" }}
                        space="65px"
                        w="75%"
                        maxW="300px"
                      >
                        <Radio value="true" size="sm" my={1} fontSize="18px">
                          {Loc.currentLang.menu.yes}
                        </Radio>
                        <Radio value="false" size="sm" my={1} fontSize="18px">
                          {Loc.currentLang.menu.no}
                        </Radio>
                      </Stack>
                    </Radio.Group>
                  </HStack>

                  <Divider
                    marginY="20px"
                    marginLeft="28px"
                    width={isMobile ? "85%" : "93%"}
                    zIndex={-1}
                  />
                </VStack>
              )}

              {/* Group-specific settings */}
              {type === "Group" && (
                <VStack>
                  <HStack
                    marginTop="20px"
                    width={isMobile ? "91%" : "70%"}
                    marginLeft={isMobile ? "26px" : "45px"}
                    space="70px"
                    zIndex={-2}
                  >
                    <Radio.Group
                      name="groupType"
                      defaultValue={GroupType.selectedPreference}
                      accessibilityLabel="pick a size"
                      onChange={(value) => handlePreferenceChange(value)}
                    >
                      <Stack
                        direction={{ base: "column", md: "row" }}
                        alignItems={{ base: "flex-start" }}
                        space="65px"
                        w="75%"
                        maxW="300px"
                      >
                        <Radio
                          value="Normal Group"
                          size="sm"
                          my={1}
                          fontSize="18px"
                        >
                          {Loc.currentLang.menu.normalGroup}
                        </Radio>
                        <Radio
                          value="Read Only Group"
                          size="sm"
                          my={1}
                          fontSize="18px"
                        >
                          {Loc.currentLang.menu.readOnlyGroup}
                        </Radio>
                        <Radio
                          value="Public Group"
                          size="sm"
                          my={1}
                          fontSize="18px"
                        >
                          {Loc.currentLang.menu.publicGroup}
                        </Radio>
                      </Stack>
                    </Radio.Group>
                  </HStack>

                  <Divider
                    marginY="20px"
                    marginLeft="28px"
                    width={isMobile ? "85%" : "93%"}
                    zIndex={-1}
                  />
                </VStack>
              )}
            </VStack>
          )}

          {/*Team Url*/}
          {!(
            Entity?.type === "Collect" ||
            type === "Collect" ||
            Entity?.type === "Group" ||
            type === "Group" ||
            type === "Club" ||
            (Entity?.type === "Team" && Entity?.subType === "Club") ||
            (Entity?.type === "PlayerOrg" && Entity?.subType === "Term")
          ) && (
            <Pressable
              width="100%"
              zIndex={-3}
              onPress={() => setAddLinkPopup(true)}
            >
              <HStack>
                <Text color="#00A7BC" fontWeight={500}>
                  +
                </Text>
                <Text color="#00A7BC" fontWeight={500}>
                  {!isCreate && linkList?.length > 0
                    ? Loc.currentLang.menu.editLinks
                    : Loc.currentLang.menu.addLinks}
                </Text>
              </HStack>
            </Pressable>
          )}

          {addLinkPopup && (
            <AddandEditLinks
              setAddLinkPopup={setAddLinkPopup}
              setLinksList={setLinksList}
              linkList={linkList}
              isCreate={isCreate}
              isCreateEvent={undefined}
              setClickedUrl={setClickedUrl}
              setShowConfirmLinkPopup={setShowConfirmLinkPopup}
            />
          )}

          {/*Color picker*/}
          {((isShowEdit &&
            Entity?.subType !== "Term" &&
            type === "Team" &&
            Entity?.subType == undefined) ||
            type === "PlayerOrg") &&
            Entity?.subType !== "Class" &&
            Entity?.subType !== "MusicGroup" &&
            Entity?.subType !== "Term" && (
              <HStack
                space={"15%"}
                zIndex={-3}
                flexWrap={isMobile ? "wrap" : null}
              >
                <HStack
                  space={"15px"}
                  zIndex={isPrimary ? -3 : ""}
                  marginBottom={isMobile ? "10px" : ""}
                >
                  <Button
                    backgroundColor={primaryColor}
                    height={"30px"}
                    width={"30px"}
                    rounded={"full"}
                    onPress={() => setIsPrimary(!isPrimary)}
                  >
                    <ColorPickerIcon
                      height={"15"}
                      width={"15"}
                      color={"white"}
                    />
                  </Button>
                  <Text color={"#808080"} fontSize={"16px"} fontWeight={400}>
                    {Loc.currentLang.menu.primaryColors}
                  </Text>
                </HStack>

                <HStack space={"15px"} zIndex={isPrimary ? -3 : ""}>
                  <Button
                    backgroundColor={secondaryColor}
                    height={"30px"}
                    width={"30px"}
                    rounded={"full"}
                    onPress={() => setIsSecondary(!isSecondary)}
                  >
                    <ColorPickerIcon
                      height={"15"}
                      width={"15"}
                      color={"white"}
                    />
                  </Button>
                  <Text color={"#808080"} fontSize={"16px"} fontWeight={400}>
                    {Loc.currentLang.menu.secondryColors}
                  </Text>
                </HStack>
              </HStack>
            )}

          {(isPrimary || isSecondary) && (
            <Box zIndex={999} left={isSecondary ? "35%" : ""} bottom={"15px"}>
              <GithubPicker
                color={primaryColor}
                //  triangle='right'
                width={"400px"}
                onChangeComplete={handleBannerColor}
              />
            </Box>
          )}

          {/*Mascot*/}
          {isShowEdit &&
            Entity?.subType !== "Term" &&
            Entity?.type !== "Event" &&
            Entity?.subType !== "Class" &&
            Entity?.subType !== "MusicGroup" &&
            Entity?.subType !== "Club" &&
            (Entity?.type == "Team" || Entity?.type == "PlayerOrg") && (
              <VStack zIndex={-3}>
                <AVMascot
                  Entity={Entity}
                  setEntity={setEntity}
                  mascotImage={mascotImage}
                  setMascotImage={setMascotImage}
                  isShowEdit={isShowEdit}
                  setProfile={setProfile}
                />
              </VStack>
            )}
        </VStack>
      </VStack>

      {isConfirmDelete && (
        <AVConfirmationModal
          showconfirmationPopup={isConfirmDelete}
          setshowconfirmationPopup={setisConfirmDelete}
          Confirmationtext={Confirmationtext}
          type={selectType}
          item={itemSelect}
          function={DeleteAccount}
          isLoader={isLoader}
        />
      )}

      {showConfirmLinkPopup && (
        <AVConfirmLinkPopup
          url={clickedUrl}
          handleCancel={() => setShowConfirmLinkPopup(false)}
        />
      )}
    </>
  );
};

export default AVCreateTeam;
